export default "__VITE_ASSET__CaGe67yI__"